import { createContext, useContext } from 'react';
import { tSubscriptionContext } from './Subscription.types';
import { SUBSCRIPTION_INITIAL_STATE } from './Subscription.constants';

export const SubscriptionContext = createContext<tSubscriptionContext>(
  SUBSCRIPTION_INITIAL_STATE,
);

export function useSubscriptionContext(): tSubscriptionContext {
  return useContext(SubscriptionContext);
}
